/** Resolve a user id from a user object, id scalar, or nested relation. */
export function resolveUserId(source) {
  if (source == null || source === '') return null;
  if (typeof source === 'object') {
    return source.id ?? source.user_id ?? null;
  }
  const numeric = Number(source);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
}

/** Human-readable label for a user reference. */
export function resolveUserLabel(source, fallback = null) {
  if (typeof source === 'object' && source) {
    return source.name || source.email || fallback;
  }
  return fallback;
}

export function userDetailsPath(userId) {
  return userId ? `/users/details/${userId}` : null;
}
